// Ordered dropdown options for the "not attending" RSVP reason. Order and
// labels are product-defined; `value` mirrors the server AttendanceReason enum.
export const ATTENDANCE_REASON_OPTIONS: { value: AttendanceReason; label: string }[] = [
  { value: 'injured', label: 'Injured' },
  { value: 'sick', label: 'Sick' },
  { value: 'medical_appointment', label: 'Medical Appointment' },
  { value: 'funeral', label: 'Funeral' },
  { value: 'wedding', label: 'Wedding' },
  { value: 'sporting_event_participating', label: 'Sporting Event - Participating' },
  { value: 'sporting_event_attending', label: 'Sporting Event - Attending' },
  { value: 'other', label: 'Other' },
];
